export const carouselInicio = [
 
   {
      "imagen" : "videos/portjulio2025.gif",
   },  
   
  
 
]